// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t7XZ8","col":"styles_col__219Z4"};